import { makeHttpRequest } from "@/shared";

import { mapNotificationSettingsFromServer } from "./mappers/mapNotificationSettingsFromServer";

export const getNotificationSettings = async () => {
    const response = (
        await makeHttpRequest({
            url: `/notification-settings`,
            method: "GET",
        })
    ).data;

    return mapNotificationSettingsFromServer(response);
};
